export default __webpack_public_path__ + "static/bunker-web-2-53de9d8f6e63d7ae23ba068c9d117d45.jpg";